import React, { useContext, useEffect, useState, useRef } from "react";

/** Components */
import {
  Button,
  ButtonGroup,
  Collapse,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  TablePagination,
  TableFooter,
  Dialog,
  Tabs,
  Tab,
  Grid,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
  Paper,
} from "@mui/material";
import ButtonWithAPICallComponent from "../../commons/ButtonWithAPICall.component";
import SelectStatusButton from "../../commons/SelectStatusButton";
import { FilterBy } from "../../commons/filter.component";
import LoadingProgress from "../../commons/LoadingProgress.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Icons */
import SearchIcon from "@mui/icons-material/Search";
import RefreshIcon from "@mui/icons-material/Refresh";

/** Api & Function */
import { getInventory, getOrganizationData, getProcess, postSync, updateInventory, changeInventoriesStatus, updateTank, createTank } from "../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import moment from "moment";
import { useTranslation } from "react-i18next";

/** Hook */
import { useDispatch } from "react-redux";

const Process = React.createContext();
const initialFilter = {
  id: "",
  status: null,
};
const initTank = {
  code: "",
  vtp: "",
  cfs: "",
  vtb: "",
  hd: "",
  hkt: "",
  vcc: "",
  hgh: "",
  vmax: "",
  vcal: "",
  description: "",
  exp_date: "",
};
const Inventory = () => {
  // boiler plate
  const [t] = useTranslation();
  const dispatch = useDispatch();

  // state
  const [data, setData] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [changeIds, setChangeIds] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [process, setProcess] = useState();
  // filter
  const [filter, setFilter] = useState({ ...initialFilter });
  const [isOpen, setOpen] = useState(false);
  const filterFunc = (item) => {
    return item.id.toString().contains(filter.id) && (!filter.groupvehicle?.id ? true : filter.groupvehicle?.id === item.groupvehicle_id);
    // && (filter.status === null ? true : item.status === filter.status.label)
  };

  // method
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleCheckBoxClick = (id) => {
    if (changeIds.includes(id)) setChangeIds((prev) => prev.filter((item) => item !== id));
    else setChangeIds((prev) => [...prev, id]);
  };
  const handleUpdateStatus = (selectedStatus) => {
    return changeInventoriesStatus({ ids: changeIds, action: selectedStatus.action });
  };
  const handleUpdateStatusResponse = (res, selectedStatus) => {
    if (res.code === 200) {
      let newStatus;
      switch (selectedStatus.action) {
        case 0:
          newStatus = "DEACTIVATED";
          break;
        case 1:
          newStatus = "ACTIVATED";
          break;
        case 4:
          setChangeIds([]);
          newStatus = "DELETED";
          break;
        default:
          break;
      }
      setData((prev) => prev.map((item) => (changeIds.includes(item.id) ? { ...item, status: newStatus } : item)));
    }
  };
  const handleRowClick = (e, row) => {
    if (e.target.type === "checkbox") return;
    setSelectedRow(row);
  };
  const handleSave = (inputData) => {
    if (!inputData) return;
    return updateInventory(inputData.id, {
      shortname: inputData.shortname,
      process: inputData.process,
    });
  };
  const handleSaveResponse = (res) => {
    if (res.code === 200) {
      setSelectedRow(null);
      setData((prev) => prev.map((item) => (item.id === res.data.id ? { ...res.data, imp_inventories: JSON.stringify(res.data.imp_inventories), tanks: item.tanks } : item)));
    }
  };
  const handleSaveTankResponse = (res, action) => {
    if (res.code !== 200) return;
    let newTank, newInventory;
    switch (action) {
      case "edit":
        newTank = selectedRow.tanks.map((item) => (item.id === res.data.id ? res.data : item));
        break;
      case "create":
        newTank = selectedRow.tanks.concat(res.data);
        break;
      default:
        break;
    }
    newInventory = data.map((item) => (item.id === res.data.inventory_id ? { ...item, tanks: newTank } : item));
    setSelectedRow((prev) => ({ ...prev, tanks: newTank }));
    setData(newInventory);
  };

  //effect
  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN KHO HÀNG"));
    getInventory().then((res) => {
      res.code === 200 && setData(res.data);
    });
    getProcess().then((res) => {
      res.code === 200 && setProcess(res.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setPage(0);
  }, [filter]);

  // render
  return (
    <Process.Provider value={process}>
      <div>
        <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
          <ButtonGroup style={{ height: 40, marginRight: 10 }}>
            <ButtonWithAPICallComponent title="Lấy dữ liệu từ ERP" api={() => postSync({ object: "inventory" })} variant="outlined">
              <RefreshIcon />
            </ButtonWithAPICallComponent>
            <Button onClick={() => setOpen((prev) => !prev)}>
              <Tooltip title="Thư mục">
                <SearchIcon />
              </Tooltip>
            </Button>
          </ButtonGroup>
        </div>
        <Collapse in={isOpen} sx={{ marginBottom: "20px" }}>
          <TextField sx={{ margin: "5px" }} value={filter.id} onChange={(e) => setFilter((prev) => ({ ...prev, id: e.target.value }))} label="ID" />
        </Collapse>
        {!data ? (
          <LoadingProgress />
        ) : (
          <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>ID</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Tên kho hàng")}</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Mã số")}</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Tên tìm kiếm")}</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Trạng thái")}</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>
                    <SelectStatusButton disabled={!changeIds.length} api={handleUpdateStatus} response={handleUpdateStatusResponse} />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.filter(filterFunc).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length ? (
                  data
                    .filter(filterFunc)
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow key={row.id} hover style={{ cursor: "pointer" }} onClick={(e) => handleRowClick(e, row, index)}>
                        <TableCell style={{ border: "0.5px solid lightgray" }}>{row.id} </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                          {row.name}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }}>{row.code}</TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }}>{row.shortname}</TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }}>{t(row.status)}</TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }}>
                          <Checkbox disabled={row.status === "DELETED"} checked={changeIds.includes(row.id)} onClick={handleCheckBoxClick.bind(this, row.id)} />
                        </TableCell>
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={50}>{t("Không có dữ liệu")}</TableCell>
                  </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    count={data.filter(filterFunc).length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        )}
        <EditDialog
          open={Boolean(selectedRow)}
          initialData={selectedRow}
          onClose={() => setSelectedRow(null)}
          onSave={handleSave}
          onSaveResponse={handleSaveResponse}
          onSaveTankResponse={handleSaveTankResponse}
        />
      </div>
    </Process.Provider>
  );
};

const EditDialog = ({ open, initialData, onClose, onSave, onSaveResponse, onSaveTankResponse }) => {
  const processTemplate = useContext(Process);
  const [t] = useTranslation();
  const [tab, setTab] = useState(0);
  const [inputData, setInputData] = useState("");
  const handleResponse = (res) => {
    onSaveResponse && onSaveResponse(res);
  };

  // method
  const handleCheckbox = (key1, key2) => {
    let newProcess = { ...inputData.process };
    newProcess[key1][key2] = !newProcess[key1][key2];
    setInputData((prev) => ({ ...prev, process: newProcess }));
  };
  // effect
  useEffect(() => {
    // setTab(0)
    if (!initialData) return;
    setInputData({
      ...initialData,
      // organization_id: initialData.organization_id,
      // imp_inventories: [] || initialData.imp_inventories && JSON.parse(initialData.imp_inventories),
      tanks: JSON.parse(JSON.stringify(initialData.tanks)),
    });
  }, [initialData]);
  useEffect(() => {
    if (!processTemplate || !initialData) return;
    let a = processTemplate;
    let aa = JSON.parse(initialData?.process); //perm cua du lieu user
    let d = {};
    Object.keys(processTemplate).forEach((key) => {
      // key: Org
      let b = a[key]; //{List: '', Update: ''}
      let bb = aa && aa[key]; //{List: 1}
      let c = {}; //c la object moi cua Org
      Object.keys(b).forEach((sub_key) => {
        //sub_key: List
        c[sub_key] = (bb && bb[sub_key]) || b[sub_key];
      });
      d[key] = c || a[key];
    });
    setInputData((prev) => ({ ...prev, process: d }));
  }, [processTemplate, initialData]);
  return (
    <Dialog open={open} onClose={onClose} maxWidth={false}>
      <DialogTitle align="center">{t("Thông tin kho hàng bán").toUpperCase()}</DialogTitle>
      <DialogContent>
        <div style={{ padding: "10px", position: "relative" }} align="center">
          <div style={{ display: "flex", justifyContent: "center", marginBottom: 10 }}>
            <Tabs value={tab} onChange={(e, newValue) => setTab(newValue)}>
              <Tab value={0} label="Thông tin cơ bản" />
              <Tab value={1} label="Thông tin bể" />
            </Tabs>
          </div>
          <div style={{ display: tab === 0 ? "grid" : "none", rowGap: 10, marginTop: 20, paddingBottom: 40 }}>
            {/* <FilterBy
                    multiple
                    getDataFunc={() => getInventory({status: 1})}
                    disableCloseOnSelect
                    limitTags={4}
                    style={{maxWidth: 400}}
                    label={t('Kho nhập')}
                    setDefaultFunc={option => setInputData(prev => ({...prev, imp_inventories: option.filter(item => inputData.imp_inventories?.includes(item.id))}))}
                    triggerSetDefaultFunc={initialData}
                    value={inputData.imp_inventories || []}
                    onChange={(e, newValue) => setInputData(prev => ({...prev, imp_inventories: newValue}))}
                    /> */}
            <FilterBy
              disabled
              getDataFunc={() => getOrganizationData({ params: { status: 1 } })}
              label={t("Tổ chức")}
              setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, organization: option.find((item) => initialData.organization_id === item.id) }))}
              triggerSetDefaultFunc={initialData}
              value={inputData.organization}
              onChange={(e, newValue) => setInputData((prev) => ({ ...prev, organization: newValue, organization_id: newValue.id }))}
            />
            <TextField label={t("Tên tìm kiếm")} value={inputData.shortname} onChange={(e) => setInputData((prev) => ({ ...prev, shortname: e.target.value }))} />
            {inputData.process &&
              Object.keys(inputData.process).map((key1) => (
                <Grid container key={key1} style={{ border: "1px solid lightgray" }}>
                  <div style={{ display: "grid", alignItems: "center", padding: "0 10px", gridTemplateColumns: "0.3fr 1.5fr" }}>
                    <div align="left">{key1}:</div>
                    <div style={{ display: "flex" }}>
                      {Object.keys(inputData.process[key1]).map((key2, index) => (
                        <div key={index} style={{ display: "flex", alignItems: "center", marginRight: 20 }}>
                          <Checkbox checked={Boolean(inputData.process[key1][key2])} onClick={() => handleCheckbox(key1, key2)} />
                          {key2}
                        </div>
                      ))}
                    </div>
                  </div>
                </Grid>
              ))}
          </div>
          <div hidden={tab !== 1} style={{ width: "100%" }}>
            <TankTab tankData={initialData?.tanks} inventoryId={initialData?.id} response={onSaveTankResponse} />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("Hủy")}</Button>
        <ButtonWithAPICallComponent variant="contained" api={() => onSave(inputData)} response={handleResponse}>
          {t("Lưu")}
        </ButtonWithAPICallComponent>
      </DialogActions>
    </Dialog>
  );
};
const TankTab = React.memo(({ tankData, inventoryId, response }) => {
  const [t] = useTranslation();
  const [selectedRow, setSelectedRow] = useState(undefined);
  const rowRef = useRef();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSaveResponse = (res, action) => {
    if (res.code === 200 && rowRef.current === selectedRow) setSelectedRow(undefined);
    response && response(res, action);
  };

  // effect
  useEffect(() => {
    rowRef.current = selectedRow;
  }, [selectedRow]);
  if (tankData)
    return (
      <React.Fragment>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>{t("Bể số")}</TableCell>
                <TableCell>Dung tích toàn phần</TableCell>
                <TableCell>Chu vi ngoài tầng 1</TableCell>
                <TableCell>Dung tích đáy</TableCell>
                <TableCell>Chiều cao đáy</TableCell>
                <TableCell>Chiều cao kiểm tra</TableCell>
                <TableCell>Thể tích hoán chỗ</TableCell>
                <TableCell>Chiều cao chứa tối đa</TableCell>
                <TableCell>Thể tích chứa tối đa</TableCell>
                <TableCell>Tồn</TableCell>
                <TableCell>Trạng thái</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tankData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length ? (
                tankData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
                  <TableRow key={index} hover style={{ cursor: "pointer" }} onClick={() => setSelectedRow(item)}>
                    <TableCell>{item.id}</TableCell>
                    <TableCell>{item.code}</TableCell>
                    <TableCell>{item.vtp}</TableCell>
                    <TableCell>{item.cfs}</TableCell>
                    <TableCell>{item.vtb}</TableCell>
                    <TableCell>{item.hd}</TableCell>
                    <TableCell>{item.hkt}</TableCell>
                    <TableCell>{item.vcc}</TableCell>
                    <TableCell>{item.hgh}</TableCell>
                    <TableCell>{item.vmax}</TableCell>
                    <TableCell>{item.vcal}</TableCell>
                    <TableCell>{t(item.status)}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={20}>{t("Không có dữ liệu")}</TableCell>
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  count={tankData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
        <AddOrEditDialog inventoryId={inventoryId} open={Boolean(selectedRow !== undefined)} initialData={selectedRow} onClose={() => setSelectedRow(undefined)} onSaveResponse={handleSaveResponse} />
      </React.Fragment>
    );
  else return "";
});
export const AddOrEditDialog = ({ open, onClose, onSaveResponse, initialData, inventoryId }) => {
  const [t] = useTranslation();
  const [inputData, setInputData] = useState({ ...initTank });
  const handleResponse = (res) => {
    onSaveResponse && onSaveResponse(res, Boolean(initialData) ? "edit" : "create");
  };
  const handleEdit = () => {
    return updateTank(inputData.id, inputData);
  };
  const handleCreate = () => {
    return createTank({
      ...inputData,
      inventory_id: inventoryId,
    });
  };
  useEffect(() => {
    if (Boolean(initialData)) setInputData({ ...initialData, exp_date: moment(initialData.exp_date).format("YYYY-MM-DD") });
    else setInputData({ ...initTank });
  }, [initialData]);
  return (
    <Dialog className="test" open={open} onClose={onClose} maxWidth={false}>
      <DialogTitle align="center">{t(Boolean(initialData) ? "Cập nhật bể" : "Thêm mới bể")}</DialogTitle>
      <DialogContent>
        <div style={{ padding: "10px 10px 10px 10px", maxWidth: 1000 }}>
          <Grid container spacing={2} columns={10}>
            <Grid item md={2}>
              <TextField label="Tên bể" onChange={(e) => setInputData((prev) => ({ ...prev, code: e.target.value }))} value={inputData.code} />
            </Grid>
            <Grid item md={2}>
              <TextField label="Dung tích toàn phần" onChange={(e) => setInputData((prev) => ({ ...prev, vtp: e.target.value }))} value={inputData.vtp} />
            </Grid>
            <Grid item md={2}>
              <TextField label="Chu vi ngoài tầng 1" onChange={(e) => setInputData((prev) => ({ ...prev, cfs: e.target.value }))} value={inputData.cfs} />
            </Grid>
            <Grid item md={2}>
              <TextField label="Dung tích đáy" onChange={(e) => setInputData((prev) => ({ ...prev, vtb: e.target.value }))} value={inputData.vtb} />
            </Grid>
            <Grid item md={2}>
              <TextField label="Chiều cao đáy" onChange={(e) => setInputData((prev) => ({ ...prev, hd: e.target.value }))} value={inputData.hd} />
            </Grid>
            <Grid item md={2}>
              <TextField label="Chiều cao kiểm tra" onChange={(e) => setInputData((prev) => ({ ...prev, hkt: e.target.value }))} value={inputData.hkt} />
            </Grid>
            <Grid item md={2}>
              <TextField label="Thể tích hoán chỗ" onChange={(e) => setInputData((prev) => ({ ...prev, vcc: e.target.value }))} value={inputData.vcc} />
            </Grid>
            <Grid item md={2}>
              <TextField label="Chiều cao chứa tối đa" onChange={(e) => setInputData((prev) => ({ ...prev, hgh: e.target.value }))} value={inputData.hgh} />
            </Grid>
            <Grid item md={2}>
              <TextField label="Thể tích chứa tối đa" onChange={(e) => setInputData((prev) => ({ ...prev, vmax: e.target.value }))} value={inputData.vmax} />
            </Grid>
            <Grid item md={2}>
              <CustomDatePicker
                format="DD/MM/YYYY"
                label={t("Ngày hết hiệu lực")}
                value={inputData.exp_date}
                onChange={(value) => setInputData((prev) => ({ ...prev, exp_date: value }))}
                sx={{ width: "100%" }}
              />
            </Grid>
          </Grid>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("Hủy")}</Button>
        <ButtonWithAPICallComponent variant="contained" api={() => (Boolean(initialData) ? handleEdit() : handleCreate())} response={handleResponse}>
          {t(Boolean(initialData) ? "Lưu" : "Thêm mới")}
        </ButtonWithAPICallComponent>
      </DialogActions>
    </Dialog>
  );
};
export default Inventory;
